export enum TypeIdEnum {
  Sms = 'Sms',
  Email = 'Email',
}
